import React from 'react'
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import styled from 'styled-components'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Switch from '@material-ui/core/Switch';
import { mergeDefaultPermissions } from './defaultPermissions'

const Container = styled.div`
  margin: 10px;
  color: #555;
  font-size: 18px;
  padding: 10px;
`;

const Item = styled.div`
  display: flex;
`;

const RolesContainer = styled(Box)`
  display: flex;
  margin-top: 25px;
  margin-bottom: 15px;
`;

const RolesList = styled(Box)`
  display: flex;
  flex-direction: column;
  font-size: 16px;
`;

const PermissionsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  width: 50%
`;

const StyledRow = styled(TableRow)`
  padding: 15px;
  border: none;
  margin: 15px;
  min-height: 20px;
`;

const StyledCell = styled(TableCell)`
  padding: 15px;
  border: none;
  margin: 15px;
  min-height: 20px;
`;

const Permissions = (props) => {
  // console.log('Permission Details: ', props)

  const [state, setState] = React.useState({
    permissions: mergeDefaultPermissions(props.profile?.permissions),
  })

  React.useEffect(() => {
    const permissions = mergeDefaultPermissions(props.profile?.permissions)
    setState({ permissions })
    props.updateParent(permissions)
  }, [props.profile])

  const handleChange = (row, type, index) => {
    // console.log('Handle CHange', row)
    // console.log('Type: ', type)

    // const id = event.target.id
    // console.log(id)
    // let int = id.split('-')[1]
    // console.log(int)
    const perms = state.permissions.map((permission, permissionIndex) => {
      if (permissionIndex !== index) return permission
      return {
        ...permission,
        [type]: !permission[type]
      }
    })
    setState({ ...state, permissions: perms })
    props.updateParent(perms)
  }

  return (
    <div>
      <Container>
        <RolesList>
        <Table
            aria-labelledby="tableTitle"
            size='small'
            aria-label="enhanced table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>View</TableCell>
                <TableCell>Update</TableCell>
                <TableCell>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { state.permissions.map((row, index) => {
                  return (
                    <StyledRow
                      hover
                      tabIndex={-1}
                      key={index}
                      // onDoubleClick={() => handleEditWo(row)}
                    >
                      <StyledCell component="td" id={row._id} scope="row" padding="none">
                        {row.type}
                      </StyledCell>
                      <StyledCell component="td"  scope="row" padding="none">
                        <Switch
                          checked={row.view}
                          onChange={() => handleChange(row, 'view', index)}
                          name={row.type}
                          id={`switch-${index}`}
                          inputProps={{ 'aria-label': 'checkbox' }}
                        />
                        
                      </StyledCell>
                      <StyledCell component="td" scope="row" padding="none">
                        <Switch
                            checked={row.update}
                            onChange={() => handleChange(row, 'update', index)}
                            name={row.type}
                            id={`switch-${index}`}
                            inputProps={{ 'aria-label': 'checkbox' }}
                          />
                      </StyledCell>
                      <StyledCell component="td"scope="row" padding="none">
                        <Switch
                            checked={row.delete}
                            onChange={() => handleChange(row, 'delete', index)}
                            name={row.type}
                            id={`switch-${index}`}
                            inputProps={{ 'aria-label': 'checkbox' }}
                          />
                      </StyledCell>
                     
                      
                    </StyledRow>
                  )})
              }
            </TableBody>
          </Table>
        </RolesList>
      </Container>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    url: state.url,
    user: state.user,
    notification: state.notification
  }
}

export default connect(mapStateToProps)(Permissions)
